module.exports = __webpack_public_path__ + "img/face4.346e38b3.gif";